<app-organization-sd
  [agency]="agencyService.agency"
>
</app-organization-sd>

<header
  fxLayout="row wrap"
  fxLayoutAlign="center center"
>
  <a
    *ngFor="let project of projects"
    fxLayout="column"
    fxLayoutAlign="space-between center"
    class="project-item-container"
    [routerLink]="['/portofoliu', project.id]"
  >
    <div
      class="project-item-image"
      [ngStyle]="{'background-image': 'url(' + project.images[0].url + ')'}"
    >
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      class="project-item-details"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="project-item-detail"
      >
        <h4
          class="project-item-detail-title"
        >
          Denumire:
        </h4>
        <h4
          class="project-item-detail-content"
        >
          {{ project.name }}
        </h4>
      </div>
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="project-item-detail"
      >
        <h4
          class="project-item-detail-title"
        >
          Apartamente:
        </h4>
        <h4
          class="project-item-detail-content"
        >
          <span
          >
            2,3 camere
          </span>
        </h4>
      </div>
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        class="project-item-detail"
      >
        <h4
          class="project-item-detail-title"
        >
          Compartimentări:
        </h4>
        <h4
          class="project-item-detail-content"
        >
          decomandate
        </h4>
      </div>
    </div>
    <div class="project-motto-container">
      <div class="project-motto">
        <h2>
          {{ project.name }}
        </h2>
        <h3>
          - Vise împlinite la timpul lor -
        </h3>
      </div>
    </div>
  </a>
  <!-- <a
    fxHide
    fxShow.gt-sm
    fxLayout="column"
    fxLayoutAlign="space-between center"
    class="project-item-container page-guide"
    [routerLink]="['/portofoliu']"
    [queryParams]="{sale_status: 'sold_out'}"
  >
    <div class="project-motto-container">
      <h3
        class="project-motto project-history"
      >
        Istoric proiecte
      </h3>
    </div>
  </a> -->
  <!-- <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    class="project-item-container page-guide about-us-guide"
    href="#about-us"
  >
    <div class="project-motto-container">
      <h3
        class="project-motto"
      >
        Despre {{ agencyService.agency.name }}
      </h3>
    </div>
  </div> -->
  <!-- <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    class="project-item-container page-guide why-us-guide"
    href="#why-us"
  >
    <div class="project-motto-container">
      <h3
        class="project-motto"
      >
        De ce {{ agencyService.agency.name }}?
      </h3>
    </div>
  </div> -->
</header>

<section
  class="properties"
>
  <h2
    class="center"
  >
    Locuințele
    <span
      class="after-title"
    >
      {{ agencyService.agency.name }}
    </span>
  </h2>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="properties-list"
  >
    <a
      class="property-item"
      [routerLink]="['/', 'apartamente', 'splaiul-unirii']"
    >
      <div
        class="property-top"
        [ngStyle]="{'background-image': 'url(' + '/assets/images/property/1.jpg' + ')'}"
      >
        <label>
          VÂNZARE
        </label>
      </div>
      <div
        class="property-bottom"
        fxLayout="column"
        fxLayoutAlign="center"
      >
        <div class="price-tag">
          <h3>
            Splaiul Unirii
          </h3>
        </div>
        <div
          fxLayout="column"
          fxLayoutAlign="space-between"
          class="property-bottom-content"
        >
          <h5>
            ÎN CURÂND
          </h5>
        </div>
      </div>
    </a>
  </div>
  <div class="center">
    <a
      mat-raised-button
      color="main-color"
      routerLink="locuinte"
    >
      vezi mai multe
    </a>
  </div>
</section>

<hr class="section-divider">

<section
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  class="why-us"
>
  <div
    fxLayout="column"
    fxLayoutAlign="center end"
    fxFlex.gt-xs="100%"
    fxFlex.gt-sm="50%"
    class="why-us-left"
  >
    <div
      fxFlex.gt-xs="20%"
      class="about-us"
      id="about-us"
    >
      <h2 class="center">
        Despre
        <span class="after-title">
          {{ agencyService.agency.name }}
        </span>
      </h2>
      <p>
        Am pornit în domeniul imobiliar din dorința de a construi clădiri rezidențiale premium în zone bine amplasate.
        Experiența acumulată în mulți ani de dezvoltări imobiliare își spune cuvântul în prezent construind imobile
        cu un grad ridicat de calitate și mereu orientate către nevoile din prezentul imobiliar. Țintim întotdeauna ca
        rezultatul muncii noastre să creeze sentimentul "de acasă" pe care îl dorim cu toții.
      </p>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <a
          mat-raised-button
          color="main-color"
          routerLink="/despre-noi"
        >
          află mai multe
        </a>
      </div>
    </div>
    <div
      fxFlex.gt-xs="80%"
      fxHide
      fxShow.gt-sm
      class="img-container"
    >
      <div
        class="img-shape"
        style="background-image: url('/assets/images/home/why_us_left_background.jpg')"
      >
      </div>
    </div>
  </div>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-sm="center start"
    fxFlex.gt-xs="100%"
    fxFlex.gt-sm="50%"
    class="why-us-right"
  >
    <div
      class="img-right-container"
      style="background-image: url('/assets/images/home/why_us_right_background.jpg')"
    >
    </div>
    <h2
      class="center"
      id="why-us"
    >
      De ce
      <span class="after-title">
        {{ agencyService.agency.name }}?
      </span>
    </h2>
    <div
      *ngFor="let reason of reasons"
      class="why-us-content"
    >
      <h3>
        {{ reason.name }}
      </h3>
      <p>
        {{ reason.description }}
      </p>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="link-wrapper"
    >
      <a
        mat-raised-button
        color="main-color"
        routerLink="despre-noi"
      >
        află mai multe
      </a>
    </div>
  </div>
</section>

<section class="bottom-section">
  <div class="img-wrapper">
    <div
      class="img-container"
      style="background-image: url('/assets/images/home/bottom_background.jpg')"
    >
    </div>
  </div>
  <app-testimonials></app-testimonials>
</section>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html